/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch } from 'react-redux';
import { CheckboxComponent } from '../../../../Display/NDC/component/NDCDetails/CMSDrug/CMSDrugInputContainer';
import { setSelectedClaimFilterNu } from '../../store/action';

const SelectedClaimInvoiceIndicator = ({
  selectedClaimFilter,
  specialConditionExists = false,
  setSuccessMessages
}) => {
  const dispatch = useDispatch();
  return (
    <div className={`col-${specialConditionExists ? '3' : '4'} mt-4`}>
      <fieldset className="custom-fieldset">
        <legend className="same-font-family">{`Invoice Status : ${
          (selectedClaimFilter && selectedClaimFilter.rebateType) || 'Regular'
        }`}</legend>
        <div className="p-0 mt-2 row">
          <div className="mui-custom-form col-12 m-0 d-flex customCheckbox flex-wrap align-items-center">
            <div
              style={{ flex: 1 }}
              className="d-flex justify-content-around align-items-center"
            >
              <div className="text-blue sub-radio no-margin">
                <CheckboxComponent
                  label="Invoiced"
                  checked={
                    selectedClaimFilter &&
                    selectedClaimFilter?.invoiceSelected &&
                    selectedClaimFilter?.invoiceSelected?.invoiced
                  }
                  labelPlacement="end"
                  disabled={false}
                  onChange={(e) => {
                    setSuccessMessages([]);
                    const nextInvoiced = e.target.checked;
                    const nextNonInvoiced =
                      !nextInvoiced && !selectedClaimFilter?.invoiceSelected?.nonInvoiced
                        ? true
                        : selectedClaimFilter?.invoiceSelected?.nonInvoiced;
                    dispatch(
                      setSelectedClaimFilterNu({
                        ...selectedClaimFilter,
                        invoiceSelected: {
                          ...selectedClaimFilter?.invoiceSelected,
                          invoiced: nextInvoiced,
                          nonInvoiced: nextNonInvoiced,
                        },
                      })
                    );
                  }}
                />
              </div>
              <div className="text-blue sub-radio no-margin">
                <CheckboxComponent
                  label="Non-Invoiced"
                  checked={
                    selectedClaimFilter &&
                    selectedClaimFilter?.invoiceSelected &&
                    selectedClaimFilter?.invoiceSelected?.nonInvoiced
                  }
                  labelPlacement="end"
                  disabled={false}
                  onChange={(e) => {
                    setSuccessMessages([])
                    const nextNonInvoiced = e.target.checked;
                    const nextInvoiced =
                      !nextNonInvoiced && !selectedClaimFilter?.invoiceSelected?.invoiced
                        ? true
                        : selectedClaimFilter?.invoiceSelected?.invoiced;
                    dispatch(
                      setSelectedClaimFilterNu({
                        ...selectedClaimFilter,
                        invoiceSelected: {
                          ...selectedClaimFilter?.invoiceSelected,
                          invoiced: nextInvoiced,
                          nonInvoiced: nextNonInvoiced,
                        },
                      })
                    );
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  );
};

export default SelectedClaimInvoiceIndicator;
